import { render, staticRenderFns } from "./CardDetailsProfiler.vue?vue&type=template&id=5eed109a&scoped=true"
import script from "./CardDetailsProfiler.vue?vue&type=script&lang=js"
export * from "./CardDetailsProfiler.vue?vue&type=script&lang=js"
import style0 from "./CardDetailsProfiler.vue?vue&type=style&index=0&id=5eed109a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eed109a",
  null
  
)

export default component.exports